module.exports = __webpack_public_path__ + "static/1-63a83dffcab5e4ac9fb5c63401a79313.jpg";